export const Tax = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.63147 3.60289L2.15959 8.99998L0.618511 7.47996C-0.206171 6.66655 -0.20617 5.34775 0.618511 4.53434L4.59717 0.610058C5.42185 -0.203353 6.75893 -0.203352 7.58361 0.610058L7.63147 0.657265C8.45615 1.47068 8.45615 2.78948 7.63147 3.60289Z"
      fill="url(#paint0_linear_5960_17586)"
    />
    <path
      d="M4.36851 8.39709L9.84039 3L11.3815 4.52002C12.2062 5.33343 12.2061 6.65223 11.3815 7.46564L7.40281 11.3899C6.57813 12.2033 5.24105 12.2033 4.41637 11.3899L4.36851 11.3427C3.54383 10.5293 3.54383 9.2105 4.36851 8.39709Z"
      fill="url(#paint1_linear_5960_17586)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_5960_17586"
        x1="0"
        y1="4.49999"
        x2="8.24998"
        y2="4.49999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5960_17586"
        x1="3.75"
        y1="7.49999"
        x2="12"
        y2="7.49999"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8B08FD" />
        <stop offset="1" stopColor="#5622FF" />
      </linearGradient>
    </defs>
  </svg>
);
